
import  { useState } from "react";
import {useRef } from "react";
import emailjs from "@emailjs/browser"
import Swal from "sweetalert2"
const Contact=()=>{
  const [result,showResult]=useState(false)
  const form=useRef()
  const sendEmail=(e)=>{
    e.preventDefault();
  emailjs.sendForm('service_c2mz4fp', 'template_qlewx5f', form.current, 'wIZ861omrA8UV6ipT')
  .then((result) => {
      console.log(result.text);
      Swal.fire({
      icon:"success",
      text: 'Message sent successfully'
  }); 
  }, (error) => {
      console.log(error.text);
  });
  e.target.reset();
  showResult(true);
}

return(
  <>
     <div className='page-header'>
      <h2 className='page-title'>Contact Us</h2>
      </div>
      <div className="container contact mt-4">
      <div className="row d-flex justify-content-center">
          <div className="col-md-6">
      <div className='card cardd'>
          <h4 className='pt-3 text-center'>Get In Touch </h4>
          <form ref={form} onSubmit={sendEmail}>
              <div className='row d-flex justify-content-center'>       
            <div className='col-lg-6'>
              <label className="mb-2"></label>
              <input type="text" className="form-control" name="user_name" required placeholder="Name*"></input>
              </div>            
            <div className='col-lg-6'>
            <label className="mb-2"></label>
          <input type="email" className="form-control"  name="user_email" required placeholder="Email*"></input>
          </div>    
          </div> 
          <label className="mt-2"></label>
        <textarea className="form-control mt-2" name="message" placeholder="Your Message*"/>
          <div className='text-center mt-3'>
      <button className="btn btn-primary w-100" type="submit" >Send</button>
          </div>
          <div className="row">
            {result ?  Swal.fire({
              icon:"success",
              text:"Message sent successfully"
            }) : <></>}
          </div>
          </form>
      </div>
      </div>
      <div className="col-md-6">
      <iframe title="address" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3037.4462172340304!2d49.93281867571179!3d40.42111727143889!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4030638f7157b94f%3A0xfa384fc53b0cf3d6!2sRizvan%20Teymurov%2063!5e0!3m2!1saz!2saz!4v1700066580271!5m2!1saz!2saz" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
      </div>
      </div>
</>
)
}
export default Contact;